export const LOG_IN_SUCCESS = 'LOG_IN_SUCCESS'
export const LOG_IN_FAILED = 'LOG_IN_FAILED'
export const LOG_OUT = 'LOG_OUT'
export const TOGGLE_VIS = 'TOGGLE_VIS'
export const GET_CATEGORIES = 'GET_CATEGORIES'
export const GET_CONTENT_ID = 'GET_CONTENT_ID'
export const PASS_ARTICLE_ID = 'PASS_ARTICLE_ID'
export const PERSIST_USER = 'PERSIST_USER'
export const GET_CONTENT = 'GET_CONTENT'
export const GET_SYNTHESIS = 'GET_SYNTHESIS'



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js